import type { IconNode } from '../types';

/**
 * @name floor-plan
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSAyMUg1YTIgMiAwIDAgMS0yLTJWNWEyIDIgMCAwIDEgMi0yaDE0YTIgMiAwIDAgMSAyIDJ2MTRhMiAyIDAgMCAxLTIgMmgtNSIgLz4KICA8cGF0aCBkPSJNOSAzdjciIC8+CiAgPHBhdGggZD0iTTIxIDEwaC03IiAvPgogIDxwYXRoIGQ9Ik0zIDE1aDkiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/floor-plan
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const floorPlan: IconNode = [
  [
    'path',
    {
      d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5',
      key: '1jbce3',
    },
  ],
  ['path', { d: 'M9 3v7', key: '1w7svm' }],
  ['path', { d: 'M21 10h-7', key: 'jsixvr' }],
  ['path', { d: 'M3 15h9', key: 'lot0kx' }],
];

export default floorPlan;
